export default __webpack_public_path__ + "static/media/warning-icon.573b728b.svg";